import { GridColumnV2, GridUtilsV2, SelectItemV2 } from '@schenck/rotec-components';
import { User } from '../models/user.model';
import { UserRole } from '../enums/user-roles.enum';
import { GridConfig } from '../models/grid-config.model';

export enum UserKeys {
  email = 'email',
  displayName = 'displayName',
  tenantName = 'tenantName',
}

export const USER_GRID_COLUMNS: GridColumnV2[] = [
  {
    key: UserKeys.email,
    title: 'ID',
    sortable: true,
  },
  {
    key: UserKeys.displayName,
    title: 'Name',
    sortable: true,
  },
  {
    key: UserKeys.tenantName,
    title: 'Tenant',
    sortable: true,
  },
] as GridColumnV2[];

export const USER_GRID_CONFIG_DEFAULT: GridConfig = {
  displayedColumns: [UserKeys.email, UserKeys.displayName, UserKeys.tenantName],
  columnOrder: [UserKeys.email, UserKeys.displayName, UserKeys.tenantName],
  columnsWidths: {
    [UserKeys.email]: 550,
    [UserKeys.displayName]: 550,
    [UserKeys.tenantName]: 600,
  },
};

export const USER_GRID_DEFAULT_FILTERS = {
  [UserKeys.email]: GridUtilsV2.multiselectFilter,
  [UserKeys.displayName]: GridUtilsV2.multiselectFilter,
  [UserKeys.tenantName]: GridUtilsV2.multiselectFilter,
};

export const MOCK_USERS: User[] = [
  {
    id: 'user1',
    email: 'johnny44@google.com',
    displayName: 'John Wick',
    tenantName: 'Tenant1',
    tenantId: 'tenant1',
  },
  {
    id: 'user2',
    email: 'johnny42@google.com',
    displayName: 'John Connor',
    tenantName: 'Tenant2',
    tenantId: 'tenant2',
  },
  {
    id: 'user3',
    email: 'johnny43@google.com',
    displayName: 'John Spartan',
    tenantName: 'Tenant3',
    tenantId: 'tenant3',
  },
  {
    id: 'user4',
    email: 'johnny14@google.com',
    displayName: 'John Carter',
    tenantName: 'Tenant4',
    tenantId: 'tenant4',
  },
];

export const USER_ROLES_ITEMS: SelectItemV2<string>[] = [
  { name: UserRole.Operator, value: UserRole.Operator },
  { name: UserRole.Supervisor, value: UserRole.Supervisor },
  { name: UserRole.Admin, value: UserRole.Admin },
  { name: UserRole.RoTec, value: UserRole.RoTec },
];
